
<p-table
  [value]="hostingData?.hostingProvider?.results"
  [tableStyle]="{'min-width': '50rem'}"
>
  <ng-template pTemplate="header">
    <tr>
      <th>IP Address</th>
      <th>Type</th>
      <th>Provider</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData>
    <tr>
      <td class="max-w-20"> {{ rowData.ip }}</td>
      <td class="max-w-12"> {{ rowData.type }}</td>
      <td> {{ rowData.isp_name }}</td>
    </tr>
  </ng-template>
</p-table>
